export default {
  getErrors: state => {
    return state.errors;
  },
  getReferenceNumber: state => {
    return state.referenceNumber;
  }
};
